<template>
    <div id="page-branch-list">
        <div class="vx-card p-6">
            <div class="vx-row">
                <div class="vx-col md:w-1/4 w-full mt-2">
                    <label class="vs-input--label">{{ $t('navMenu.school') }}</label>
                    <v-select class="" v-model="selectedOrganizationBranch" :clearable="false"
                        :options="organizationBranchOptions" @input="changeData">
                        <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                    </v-select>
                </div>
                <div class="vx-col md:w-1/4 w-full mt-2">
                    <label class="vs-input--label">{{ $t('attendance.classRoom') }}</label>
                    <v-select class="" v-model="classRoomModel" :clearable="false" :options="classRoomOptions">
                        <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                    </v-select>
                </div>
                <div class="vx-col md:w-1/4 w-full mt-2">
                    <label class="vs-input--label">{{ $t('attendance.student') }}</label>
                    <v-select class="" v-model="selectedStudent" :clearable="false" :options="studentOptions">
                        <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                    </v-select>
                </div>

                <div class="vx-col md:w-1/4 w-full mt-2">
                    <label class="vs-input--label">{{ $t('attendance.alreadyCheckin') }}</label>
                    <v-select class="" v-model="selectedIsCheckIn" :clearable="false" :options="isCheckInOptions">
                        <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                    </v-select>
                </div>
                <div class="vx-col md:w-1/4 w-full mt-2">
                    <label class="vs-input--label">{{ $t('attendance.late') }}</label>
                    <v-select class="" v-model="selectedIsLate" :clearable="false" :options="isLateOptions">
                        <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                    </v-select>
                </div>

                <div class="vx-col md:w-1/4 w-full mt-2">
                    <label class="vs-input--label">{{ $t('timeKeeping.teachingSchedule') }}</label>
                    <v-select v-model="workShiftModel" :options="workShiftOptions">
                        <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                    </v-select>
                </div>

                <div class="vx-col md:w-1/4 w-full mt-2">
                    <label class="vs-input--label">{{ $t('attendance.times') }}</label>
                    <div class="flex-grow">
                        <date-range-picker class="w-full" ref="picker" :locale-data="{ format: 'dd/mm/yyyy' }"
                            :opens="'right'" @update="dateRangePicker" v-model="dateRange">
                        </date-range-picker>
                    </div>
                </div>
                <div class="vx-col md:w-1/4 w-full mt-2">
                    <label class="vs-input--label">{{ $t('attendance.shiftType') }}</label>
                    <v-select v-model="shiftTypeModel" :options="shiftTypeOptions"> 
                        <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                    </v-select>
                </div>

                <!--                <div class="vx-col md:w-1/4 w-full mt-8 items-center">-->
                <!--                    <vs-input class="mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery"-->
                <!--                        @input="updateSearchQuery" :placeholder="$t('button.search')" />-->
                <!--                </div>-->
            </div>
            <div class="flex flex-wrap items-center mt-2">
                <vs-button class="mt-4 mr-4" @click="filter" :disabled="!validateForm" icon="icon-search"
                    icon-pack="feather">{{ $t('attendance.filter') }}
                </vs-button>
                <vs-button class="mt-4 mr-4" @click="exportFile" :disabled="!validateForm" iconPack="feather"
                    icon="icon-download">
                    {{ this.$t('timeKeeping.createReport') }}</vs-button>
                <vs-button class="mt-4" iconPack="feather" icon="icon-download" @click="generateReport">{{
                        $t('attendance.export') }}</vs-button>
                <div class="mt-4 flex-1 flex justify-end">
                    <p class="font-bold mr-4">{{ $t('attendance.checkin') }}: <span class="text-primary">{{
                        totalStudentElements }}</span></p>
                    <p class="font-bold">{{ $t('attendance.notCheckin') }}:<span class="text-primary">{{
                        totalStudentNoCheckin }}</span></p>
                </div>
            </div>
            <!-- AgGrid Table -->
            <ag-grid-vue style="height: 55vh" ref="agGridTable" class="ag-theme-material w-100 my-4 ag-grid-table"
                :columnDefs="columnDefs" :defaultColDef="defaultColDef" :rowData="workShiftData" :animateRows="true"
                :localeText="{ noRowsToShow: this.$t('menuCamera.noRowsToShow') }" paginationPageSize="20"
                :pagination="true" @pagination-changed="onPaginationChanged" @grid-ready="onGridReady"
                :autoSizeStrategy="autoSizeStrategy" tooltipShowDelay="0" tooltipHideDelay="5000"
                :tooltipMouseTrack="true">
            </ag-grid-vue>

            <div class="vx-row" v-if="workShiftData.length > 0">
                <div class="w-full flex">
                    <div style="min-width:200px">
                        <span class="content-page font-bold ml-4">{{ $t('dashboard.display') }}: </span><span
                            class="text-page">{{
                        countElementPage > totalElements ? totalElements : countElementPage
                    }} /
                            {{ totalElements }} </span>
                    </div>
                    <vs-pagination :total="totalPages" v-model="currentPage" @change="loadPage" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select'
import { AgGridVue } from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import authConfig from '@/../auth_config.json';
import moment from 'moment'; // Vuesax
import Pagination from "../../ui-elements/Pagination.vue"
import CellRendererActions from './cell-renderer/CellRendererActions'
import CellRendererStatus from './cell-renderer/CellRendererStatus'
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import Datepicker from 'vuejs-datepicker';
import DateRangePicker from '../../../components/vue2-daterange-picker/components/DateRangePicker.vue'

export default {
    components: {
        AgGridVue,
        vSelect,
        // Cell Renderer
        Datepicker,
        Pagination,
        CellRendererActions,
        CellRendererStatus,
        DateRangePicker,
        flatPickr
    },
    data() {
        return {
            classId: null,
            classRoomOptions: [],
            workShiftOptions: [],
            workShiftId: null,
            searchQuery: "",
            // AgGrid
            gridApi: null,
            defaultColDef: {},
            columnDefs: [
                {
                    headerName: this.$t('attendance.code'),
                    field: 'employeeCode',
                    minWidth: 100
                },
                {
                    headerName: this.$t('attendance.fullName'),
                    field: 'fullName',
                    width: 200
                },
                {
                    headerName: this.$t('attendance.shift'),
                    field: 'displayGroupName',
                    width: 200,
                    tooltipField: 'displayGroupName',
                },
                {
                    headerName: this.$t('attendance.classRoom'),
                    field: 'className',
                    width: 200,
                },
                {
                    headerName: this.$t('attendance.date'),
                    field: 'date',
                    width: 130,
                },
                {
                    headerName: this.$t('attendance.inShift'),
                    field: 'recordingTime',
                    width: 150,
                },
                {
                    headerName: this.$t('attendance.status'),
                    field: 'status',
                    width: 150,
                    cellRenderer: 'CellRendererStatus'
                },
                {
                    headerName: this.$t('attendance.actions'),
                    field: 'actions',
                    width: 150,
                    cellRenderer: 'CellRendererActions'
                },
            ],
            shiftTypeOptions: [
                { value: null, label: 'Tất cả' },
                { value: 1, label: 'Ca ngày' },
                { value: 2, label: 'Ca TKB' }
            ],
            shiftTypeModel: { value: null, label: 'Tất cả' },
            studentData: [],
            workShiftData: [],
            organizationBranchOptions: [],
            studentOptions: [
                { value: null, label: this.$t('menuOrganization.all') }
            ],
            selectedOrganizationBranchValue: null,
            selectedStudentValue: null,
            dateRange: {
                endDate: new Date(),
                startDate: (() => {
                    let date = new Date();
                    date.setHours(0, 0, 0);
                    return date
                })()
            },
            isCheckIn: null,
            isCheckInOptions: [
                { value: null, label: this.$t('menuOrganization.all') },
                { value: true, label: this.$t('attendance.checkin') },
                { value: false, label: this.$t('attendance.notCheckin') }
            ],
            isLate: null,
            isLateOptions: [
                { value: null, label: this.$t('menuOrganization.all') },
                { value: true, label: this.$t('attendance.late') }
            ],
            autoSizeStrategy: {
                type: 'fitGridWidth',
            },
            totalPages: 0,
            currentPage: 1,
            countElementPage: 0,
            totalElements: 0,
            totalStudentElements: 0,
            totalStudentNoCheckin: null,
        }
    },
    created() {
        if (this.$route.query.isCheckin && this.$route.query.isCheckin == 'true') {
            this.selectedIsCheckIn = { value: true, label: this.$t('attendance.checkin') };
        } else if (this.$route.query.isCheckin && this.$route.query.isCheckin == 'false') {
            this.selectedIsCheckIn = { value: false, label: this.$t('attendance.notCheckin') };
        }
        if (this.$route.query.employeeId) this.selectedStudentValue = this.$route.query.employeeId;
        if (this.$route.query.isLate == 'true') {
            this.selectedIsLate = { value: true, label: this.$t('attendance.late') };
        }
        if (this.$route.query.classId) {
            this.classId = parseInt(this.$route.query.classId)
        }
        if (this.$route.query.teachingScheduleId) {
            this.workShiftId = parseInt(this.$route.query.teachingScheduleId)
        }
        if (this.$route.query.date) {
            let date = new Date(parseInt(this.$route.query.date));
            this.dateRange.startDate = new Date(date.setHours(0, 0, 0));
            this.dateRange.endDate = new Date(date.setHours(23, 59, 59));
        }
        this.initScreen()
    },
    watch: {
        '$store.state.windowWidth'(val) {
            if (val <= 1024) {
                this.maxPageNumbers = 5;
            } else {
                this.maxPageNumbers = 7;
            }

            if (val > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },
        '$store.state.reduceButton'() {
            setTimeout(() => {
                this.gridApi.sizeColumnsToFit();
            }, 650);
        },
        '$store.state.isUpdateCheckInCheckOut'(val) {
            if (val) {
                this.initScreen();
                this.$store.commit('UPDATE_CHECKIN_CHECKOUT', false);
            }
        }
    },
    computed: {
        classRoomModel: {
            get() {
                let object = this.classRoomOptions.find(el => el.value == this.classId);
                if (!object) return;
                return {
                    label: object.label,
                    value: object.value
                }
            },
            async set(object) {
                this.classId = object ? object.value : null;
                await this.loadStudent();
            }
        },
        workShiftModel: {
            get() {
                let object = this.workShiftOptions.find(el => el.value == this.workShiftId);
                if (!object) return;
                return {
                    label: object.label,
                    value: object.value
                }
            },
            set(object) {
                this.workShiftId = object ? object.value : null;
            }
        },
        selectedOrganizationBranch: {
            get() {
                return {
                    label: this.organizationBranchString(this.selectedOrganizationBranchValue),
                    value: this.selectedOrganizationBranchValue
                }
            },
            async set(obj) {
                this.selectedOrganizationBranchValue = obj ? obj.value : null
                // await this.getClassRoom();
                await this.loadStudent();
                await this.getTeachingSchedule();
            }
        },
        selectedStudent: {
            get() {
                return {
                    label: this.employeeString(this.selectedStudentValue),
                    value: this.selectedStudentValue
                }
            },
            set(obj) {
                this.selectedStudentValue = obj.value
            }
        },
        selectedIsCheckIn: {
            get() {
                return {
                    label: this.isCheckinString(this.isCheckIn),
                    value: this.isCheckIn
                }
            },
            set(obj) {
                this.isCheckIn = obj.value
            }
        },
        selectedIsLate: {
            get() {
                return {
                    label: this.isLateString(this.isLate),
                    value: this.isLate
                }
            },
            set(obj) {
                this.isLate = obj.value
            }
        }
    },
    methods: {
        changeData() {
            this.getClassRoom()
        },
        exportFile() {
            let searchInfo = {
                organizationBranchId: this.selectedOrganizationBranchValue,
                studentIds: this.selectedStudent.value ? [this.selectedStudent.value] : null,
                start: moment(this.dateRange.startDate).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }),
                end: moment(this.dateRange.endDate).set({ hour: 23, minute: 59, second: 59, millisecond: 59 }),
                isCheckIn: this.isCheckIn,
                isLate: this.isLate,
                faceType: "school-student",
                isStudent:true,
                shiftType:this.shiftTypeModel.value,

            };

            this.$vs.loading();
            this.$crm.post('/time-keeping/create', searchInfo).then((response) => {
                this.$vs.loading.close();
                window.open(authConfig.crmDomain + "file/" + response.data.fileName + "?access_token=" + localStorage.getItem("access_token"), "_blank");
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Có lỗi sảy ra!',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        generateReport() {
            let data = {
                organizationBranchId: this.selectedOrganizationBranchValue,
                studentIds: this.selectedStudent.value ? [this.selectedStudent.value] : null,
                start: moment(this.dateRange.startDate).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }),
                end: moment(this.dateRange.endDate).set({ hour: 23, minute: 59, second: 59, millisecond: 59 }),
                isCheckIn: this.isCheckIn,
                isLate: this.isLate,
                isSchool: true,
                classId: this.classId,
                teachingScheduleId: this.workShiftId
            }

            this.$vs.loading()
            this.$crm.post(`/time-keeping/export?isStudent=true`, data).then(res => {
                window.open(authConfig.crmDomain + "file/" + res.data.fileName + "?access_token=" + localStorage.getItem("access_token"), "_blank");
                this.$vs.loading.close()
            }).catch(err => {
                this.$vs.loading.close()
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            })
        },
        getClassRoom() {
            return new Promise((resolve, reject) => {
                let userInfo = JSON.parse(localStorage.getItem('userInfo'));
                // this.classRoomOptions = [];
                const payload = {
                    organizationBranchId: this.selectedOrganizationBranchValue,
                    organizationId: userInfo.organization.id,
                    status: true
                }
                this.$vs.loading()
                this.$crm.post('/school-classroom/get-all-class', payload).then((res) => {
                    console.log('res', res)
                    this.classRoomOptions = res.data.map(el => {
                        return {
                            label: el.className,
                            value: el.id
                        }
                    });
                    this.classRoomOptions.unshift({ label: 'Tất cả', value: null });
                    resolve()
                    this.$vs.loading.close()
                }).catch((err) => {
                    reject()
                    this.$vs.loading.close()
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                })
            })
        },
        dateRangePicker: function () {
            this.dateRange.startDate = new Date(this.dateRange.startDate.setHours(0, 0, 0));
            this.dateRange.endDate = new Date(this.dateRange.endDate.setHours(23, 59, 59));
        },
        updateSearchQuery(val) {
            this.gridApi.setGridOption('quickFilterText', val);
        },
        organizationBranchString(id) {
            let organizationBranch = this.organizationBranchOptions.find(x => x.value === id);
            return (organizationBranch && organizationBranch.label) || 'Chưa xác định';
        },
        employeeString(id) {
            let student = this.studentOptions.find(x => x.value === id);
            return (student && student.label) || 'Chưa xác định';
        },
        isCheckinString(id) {
            let isCheckIn = this.isCheckInOptions.find(x => x.value === id);
            return (isCheckIn && isCheckIn.label) || 'Chưa xác định';
        },
        isLateString(id) {
            let isLate = this.isLateOptions.find(x => x.value === id);
            return (isLate && isLate.label) || 'Chưa xác định';
        },
        addEmployee() {
            this.$router.push(`/user/add-employee?branch_id=${this.selectedOrganizationBranchValue}`).catch(() => {
            });
        },
        validateForm() {
            return !this.errors.any()
        },
        getTeachingSchedule() {
            return new Promise((resolve, reject) => {
                const payload = {
                    organizationBranchId: this.selectedOrganizationBranchValue,
                    type: 1,
                    valueWorkshift: "GV"
                }
                this.$vs.loading()
                this.workShiftOptions = [];
                let userInfo = JSON.parse(localStorage.getItem('userInfo'));
                this.$crm.post('/teaching-schedule/find-all', payload).then((res) => {
                    this.workShiftOptions = res.data.filter(el => el.organizationId == userInfo.organization.id).map(el => {
                        return {
                            label: el.name + " " + el.startTime + "-" + el.endTime,
                            value: el.id
                        }
                    });
                    this.workShiftOptions.unshift({ label: 'Tất cả', value: null })
                    resolve()
                    this.$vs.loading.close()
                }).catch((err) => {
                    reject()
                    this.$vs.loading.close()
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                })
            })
        },
        filter() {
            let searchInfo = {
                organizationBranchId: this.selectedOrganizationBranchValue,
                studentIds: this.selectedStudent.value ? [this.selectedStudent.value] : null,
                start: moment(this.dateRange.startDate).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }),
                end: moment(this.dateRange.endDate).set({ hour: 23, minute: 59, second: 59, millisecond: 59 }),
                isCheckIn: this.isCheckIn,
                isLate: this.isLate,
                isSchool: true,
                classId: this.classId,
                teachingScheduleId: this.workShiftId,
                faceType: "school-student",
                shiftType: this.shiftTypeModel.value
            }
            this.totalStudentElements = 0
            this.$vs.loading()
            this.$crm.post('/time-keeping/find', searchInfo).then((response) => {
                let workShiftData = response.data.sort((item1, item2) => {
                    if (moment(item1.date) < moment(item2.date)) return 1;
                    if (moment(item1.date) > moment(item2.date)) return -1;
                    // if (Math.abs(item1.startHour - new Date().getHours()*60 - new Date().getMinutes()) > Math.abs(item2.startHour - new Date().getHours()*60 - new Date().getMinutes())) return 1
                    // if (Math.abs(item1.startHour - new Date().getHours()*60 - new Date().getMinutes()) < Math.abs(item2.startHour - new Date().getHours()*60 - new Date().getMinutes())) return -1
                    return 0
                })
                // this.totalStudentElements = workShiftData.reduce((total, item) => {
                //     return item.checkinTime ? total + 1 : total;
                // }, 0);
                // let dataStudent = workShiftData.filter(item => item.checkinTime)
                // console.log(dataStudent)
                // this.totalStudentElements = dataStudent.length;
                this.workShiftData = workShiftData.map(item => {
                    if (item.checkinTime) {
                        this.totalStudentElements++
                    }

                    // let result = this.studentData.find(x => x.id == item.employeeId)
                    // if (result) {
                    let object = this.classRoomOptions.find(el => item.classIds && item.classIds.includes(el.value));
                    if (object) item.className = object.label;
                    item.check = true
                    item.endHour = Math.floor(item.endHour / 60) + ':' + (item.endHour % 60 > 9 ? item.endHour % 60 : '0' + item.endHour % 60)
                    item.startHour = Math.floor(item.startHour / 60) + ':' + (item.startHour % 60 > 9 ? item.startHour % 60 : '0' + item.startHour % 60)
                    item.displayGroupName = item.workShiftName + '  ' + item.startHour + '-' + item.endHour;
                    item.branchId = this.selectedOrganizationBranchValue;
                    if (item.checkinTime || item.checkoutTime) item.status = true
                    if (!item.checkinTime && !item.checkoutTime) item.status = false
                    item.recordingTime = item.checkinTime ? item.checkinTime : item.checkoutTime
                    // }
                    return item;
                })


                if (this.isCheckIn == null) {
                    this.workShiftData = this.workShiftData.filter(x => x.check == true);
                } else if (this.isCheckIn == true) {
                    this.workShiftData = this.workShiftData.filter(x => x.check == true && x.status == true);
                } else if (this.isCheckIn == false) {
                    this.workShiftData = this.workShiftData.filter(x => x.check == true && x.status == false);
                }
                if (this.classId) this.workShiftData = this.workShiftData.filter(x => x.classIds && x.classIds.includes(this.classId))
                this.countElementPage = this.currentPage * 20;
                this.totalElements = this.workShiftData.length;
                this.totalStudentNoCheckin = this.totalElements - this.totalStudentElements
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        // exportFile() {
        //     let searchInfo = {
        //         organizationBranchId: this.selectedOrganizationBranchValue,
        //         employeeId: this.selectedStudent.value ? [this.selectedStudent.value] : null,
        //         start: moment(this.dateRange.startDate).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }),
        //         end: moment(this.dateRange.endDate).set({ hour: 23, minute: 59, second: 59, millisecond: 59 }),
        //         isCheckIn: this.isCheckIn,
        //         isLate: this.isLate,
        //         faceType: "school-student"
        //     };

        //     this.$vs.loading();
        //     this.$crm.post('/time-keeping/create', searchInfo).then((response) => {
        //         this.$vs.loading.close();
        //         window.open(authConfig.crmDomain + "file/" + response.data.fileName + "?access_token=" + localStorage.getItem("access_token"), "_blank");
        //     }).catch((err) => {
        //         this.$vs.loading.close();
        //         return this.$vs.notify({
        //             title: 'Có lỗi sảy ra!',
        //             text: err.response.data.message || err.response.data.error_description || err.response.data.error,
        //             iconPack: 'feather',
        //             icon: 'icon-alert-circle',
        //             color: 'danger'
        //         });
        //     });
        // },
        onGridReady(params) {
            this.gridApi = params.api;
        },

        onPaginationChanged() {
            if (this.gridApi) {
                this.totalPages = this.gridApi.paginationGetTotalPages();
            }
        },
        loadPage: function (currentPage) {
            if (this.gridApi) this.gridApi.paginationGoToPage(currentPage - 1)
        },
        async initScreen() {
            let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]')
            if (branchList.length == 0) {
                return this.$vs.notify({
                    text: 'Hiện tại không tồn tại chi nhánh nào',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }
            this.organizationBranchOptions = branchList.filter(x => x.organizationBranchType === 3).map(item => {
                return { value: item.id, label: item.organizationBranchName }
            })
            this.organizationBranchOptions.unshift({ value: null, label: this.$t('menuOrganization.all') })
            let branchId = this.$route.query.branch_id;
            let index = 0;
            if (branchId) {
                index = this.organizationBranchOptions.findIndex(item => item.value == branchId)
                this.selectedOrganizationBranch = this.organizationBranchOptions[index > -1 ? index : 0];
            }
            await this.getTeachingSchedule();
            await this.getClassRoom();
            await this.loadStudent()
            this.filter();
        },
        loadStudent() {
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                let userInfo = JSON.parse(localStorage.getItem('userInfo'))
                let schoolStudentSearchDTO = {
                    organizationBranchId: this.selectedOrganizationBranchValue,
                    organizationId: userInfo.organization.id,
                    enabled: true,
                    pageNumber: 1,
                    pageSize: 1000,
                    sort: 'id',
                    classId: this.classId
                }
                this.$crm.post('/school-student/find-by-condition', schoolStudentSearchDTO).then((response) => {
                    this.studentData = response.data.content;
                    this.studentOptions = response.data.content.map(item => {
                        return {
                            value: item.id,
                            label: item.fullName,
                        }
                    });
                    if (this.studentOptions.length > 0 && this.selectedStudentValue) {
                        let employee = this.studentOptions.find(x => x.value == this.selectedStudentValue);
                        this.selectedStudent = employee;
                    }
                    this.studentOptions.unshift({ value: null, label: this.$t('menuOrganization.all') })
                    setTimeout(() => {
                        this.gridApi.sizeColumnsToFit();
                    }, 180);
                    resolve()
                    this.$vs.loading.close();
                }).catch((err) => {
                    reject()
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        title: 'Có lỗi sảy ra!',
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },

        search() {
            this.currentPage = 1;
            if (this.gridApi) this.gridApi.paginationGoToPage(this.currentPage - 1)
            this.filter();
        }
    },
}
</script>

<style lang="scss">
.ag-paging-panel {
    display: none;
}
</style>
